import { ExternalAppLayout, type ExternalAppLayoutProps } from 'routes/components/ExternalAppLayout/ExternalAppLayout'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'

/**
 * `ExternalAppLayout` dressed for the signed-out auth flow: grey page surface, horizontal gutters and
 * a seamless header, so an `AuthCard` stays put as the user moves between login, MFA and password
 * reset. `sx` and `slotProps.header.sx` merge over those defaults rather than replacing them.
 */
export const AuthPageLayout: Settle.FC<ExternalAppLayoutProps> = ({ children, sx, slotProps, ...props }) => (
  <ExternalAppLayout
    {...props}
    sx={mergeSx({ backgroundColor: ({ tokens }) => tokens.ThemeColorCommonBackground, px: 3 }, sx)}
    slotProps={{
      ...slotProps,
      header: {
        ...slotProps?.header,
        sx: mergeSx({ '&&': { borderBottomColor: 'transparent' } }, slotProps?.header?.sx),
      },
    }}
  >
    {children}
  </ExternalAppLayout>
)
